if (!customElements.get('localization-form')) {
  customElements.define(
    'localization-form',
    class LocalizationForm extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
          buttons: this.querySelectorAll('button'),
        };
        this.elements.buttons.forEach((button) => {
          button.addEventListener('click', this.openSelector.bind(this, button));
          button.addEventListener('focusout', this.closeSelector.bind(this, button));
        });
        this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

        this.querySelectorAll('a').forEach((item) => {
          if(item.href.includes('#') || item.dataset.prevent) {
            item.addEventListener('click', this.onItemClick.bind(this))
          }
        });

        this.btnSubmit = this.querySelector('[localization-submit]');
        if (!this.btnSubmit) return;
        this.btnSubmit.addEventListener('click', () => {
          const form = this.querySelector('form');
          if (form) form.submit();
        });
      }

      hidePanel(button) {
        button.setAttribute('aria-expanded', 'false');
        this.buttonPanel(button)?.setAttribute('hidden', true);
      }

      onContainerKeyUp(event) {
        if (event.code.toUpperCase() !== 'ESCAPE') return;

        this.querySelectorAll('[aria-expanded="true"]').forEach((button, index) => {
          this.hidePanel(button);
          index || event.stopPropagation();
          button.focus();
        });
      }

      replaceButtonState(clickedLang, button) {
        const buttonContent = button.querySelector("[data-button-content]");
        const previousLocale = button.lang
        const previousContent = buttonContent.innerHTML
        const previousHref = button.dataset.href

        buttonContent.innerHTML = clickedLang.innerHTML
        button.dataset.value = clickedLang.dataset.value
        button.dataset.href = clickedLang.href
        button.hreflang = clickedLang.hreflang
        button.lang = clickedLang.lang

        clickedLang.href = previousHref
        clickedLang.innerHTML = previousContent
        clickedLang.dataset.value = previousLocale
        clickedLang.hreflang = previousLocale
        clickedLang.lang = previousLocale
      }

      onItemClick(event) {
        event.preventDefault();
        const panelId = event.currentTarget.closest('[data-panel]').dataset.panel;
        const button = this.querySelector(`[aria-controls="${panelId}"]`);
        this.querySelector(`[data-input="${panelId}"]`).value = event.currentTarget.dataset.value;
        this.hidePanel(button);
        if(event.target.dataset?.prevent) {
          // Let a little time span for other scripts before change attributes
          setTimeout(() => {
            this.replaceButtonState(event.target, button);
          }, 10)
          return
        }

        const form = this.querySelector('form');
        if (form) form.submit();
      }

      buttonPanel(button) {
        const panelId = button.getAttribute('aria-controls');
        return panelId && this.querySelector(`[data-panel="${panelId}"]`);
      }

      openSelector(button) {        
        const time = window[button.getAttribute('aria-controls')] + 300;
        if (time > new Date().getTime()) return;
        button.focus();
        this.buttonPanel(button)?.toggleAttribute('hidden');
        
        button.setAttribute(
          'aria-expanded',
          (button.getAttribute('aria-expanded') === 'false').toString()
        );
      }

      closeSelector(button, event) {
        window[button.getAttribute('aria-controls')] = new Date().getTime();
        setTimeout(() => {
          if (!this.contains(document.activeElement)) {
            const isChild =
              this.buttonPanel(button).contains(event.relatedTarget) || button.contains(event.relatedTarget);
            if (!event.relatedTarget || !isChild) {
              this.hidePanel(button);
            }
          } else {
            this.elements.buttons.forEach((btn) => {
              if (button.getAttribute('aria-controls') !== btn.getAttribute('aria-controls')) {
                const isChild = this.buttonPanel(button).contains(event.relatedTarget) || button.contains(event.relatedTarget);
                !isChild && this.hidePanel(button);
              }
            });
          }
        });
      }
    }
  );
}
